import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H3 from '@base/H3/H3';
import { breakpoints, mediaQuery, Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import useBatchDetails from '@api/hooks/batch/useBatchDetails';
import BatchCTASection from './BatchCTASection';

const Wrapper = styled.div`
  grid-column: span 24;
  margin-bottom: ${Spacings.SPACING_16B};
  background: var(--color-base-0);
  @media only screen and (max-width: 47.95em) {
    grid-column: span 10;
    margin-bottom: ${Spacings.SPACING_12B};
  }
`;

const CourseTitle = styled(H3)`
  width: 73%;
  transition: all 300ms ease;
  color: var(--color-text-primary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    margin: ${Spacings.SPACING_1B} 0 ${Spacings.SPACING_3B};
  }
`;

const SmallHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  background-color: var(--color-base-1);
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_8B};
  transition: all 300ms ease;
  flex-direction: column;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    padding: ${Spacings.SPACING_4B};
    & > h3 {
      display: none;
    }
    & > button {
      width: 100%;
    }
  }
`;

const SmallHeaderWrapper = styled(Wrapper)`
  opacity: 0;
  z-index: 0;
  display: flex;
  border-radius: 0 0 ${Spacings.SPACING_2B} ${Spacings.SPACING_2B};
  position: fixed;
  width: 1136px;
  transition: all 300ms ease;
  justify-content: space-between;
  background-color: var(--color-base-0);
  box-shadow: ${boxShadowGenerator()};
  top: -72px;
  &.scrolled {
    opacity: 1;
    z-index: 2;
    @media only screen and (min-width: 47.95em) {
      top: ${Spacings.SPACING_18B};
    }
    @media only screen and (max-width: 47.95em) {
      display: flex;
      width: 100%;
      bottom: 0;
      left: 0;
      padding: 0;
      top: initial;
      margin-bottom: 0;
      box-shadow: 0px -16px 32px var(--color-shadow);
      border-radius: 0;
      & h1 {
        display: none;
      }
    }
    ${mediaQuery.uptoMobile} {
      display: none;
    }
  }
  @media only screen and (max-width: 47.95em) {
    display: none;
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const BatchSmallHeader = ({
  scroll,
  batchUID,
  handlePurchase,
  isRecordedOrHybrid
}) => {
  const { batchDetails: batch, isValidating: isLoading } =
    useBatchDetails(batchUID);
  const name = batch?.name;

  return (
    <SmallHeaderWrapper scroll={scroll} className={scroll ? 'scrolled' : ''}>
      <SmallHeader>
        {!isRecordedOrHybrid && (
          <CourseTitle lineClamp={1} as="h1">
            {name}
          </CourseTitle>
        )}
        <BatchCTASection
          batchUID={batchUID}
          batch={batch}
          isLoading={isLoading}
          isSmallHeader
          handlePurchase={handlePurchase}
        />
      </SmallHeader>
    </SmallHeaderWrapper>
  );
};

export default BatchSmallHeader;

BatchSmallHeader.propTypes = {
  batchUID: PropTypes.string.isRequired,
  scroll: PropTypes.bool.isRequired
};
